/* Velora: free gift lines (Velora törlőkendő + díszcsomagolás) in every cart.
 *
 * Rule: if the cart has at least one paid physical line, both gift variants are in the cart once, with the
 * line property _velora_gift = "1". Without a paid physical line the gift lines are removed.
 * Only runs when window.veloraConfig.gifts.enabled and BOTH gift variants cost 0. Otherwise it does nothing.
 *
 * One request at a time, debounced, never loops: after a change the cart is re-read and the result is
 * only announced to the theme (cartUpdate), never re-synced because of our own change.
 * Public: window.VeloraGifts.sync(knownCart?) -> Promise<boolean changed> (awaited by velora-delivery.js before checkout).
 * knownCart (optional): a cart.js object the caller has just read; the first pass uses it instead of reading again (2026-11-01).
 */
(function () {
  'use strict';
  var cfg = window.veloraConfig && window.veloraConfig.gifts;
  if (!cfg || !cfg.enabled || !cfg.cloth || !cfg.wrap || !cfg.cloth.id || !cfg.wrap.id) return;
  if (window.VeloraGifts) return;

  if (Number(cfg.cloth.price) !== 0 || Number(cfg.wrap.price) !== 0) {
    if (window.console && console.warn) console.warn('[Velora gifts] A gift variant price is not 0 Ft, so the gift sync is off.');
    return;
  }

  var nativeFetch = window.fetch.bind(window);   // our own requests skip the fetch watcher below
  var root = (document.documentElement.getAttribute('data-root') || '/').replace(/\/?$/, '/');
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) root = window.Shopify.routes.root;
  var GIFT_IDS = [Number(cfg.cloth.id), Number(cfg.wrap.id)];
  var inflight = null;
  var rerun = false;
  var timer = null;
  var failedAt = 0;
  var warned = false;

  function isGift(item) {
    return GIFT_IDS.indexOf(Number(item.variant_id)) > -1 || (item.properties && item.properties._velora_gift === '1');
  }
  function isPaidPhysical(item) {
    return !isGift(item) && item.price > 0 && item.requires_shipping === true;
  }
  function warnOnce(message) {
    if (warned) return;
    warned = true;
    if (window.console && console.warn) console.warn('[Velora gifts] ' + message);
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }
  function readCart() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  /* One pass: compare the cart with the rule and fix it. Resolves with the fresh cart when something changed, else null. */
  function pass(known) {
    return (known && Array.isArray(known.items) ? Promise.resolve(known) : readCart()).then(function (cart) {
      var items = cart.items || [];
      var wanted = items.some(isPaidPhysical);
      var giftLines = items.filter(isGift);
      var steps = Promise.resolve();
      var changed = false;

      if (!wanted) {
        var updates = {};
        giftLines.forEach(function (line) { updates[line.key] = 0; });
        if (giftLines.length) {
          changed = true;
          steps = steps.then(function () { return post('cart/update.js', { updates: updates }); });
        }
      } else {
        var toAdd = [];
        var fix = [];
        var drop = {};
        var dropCount = 0;
        GIFT_IDS.forEach(function (id) {
          var lines = giftLines.filter(function (l) { return Number(l.variant_id) === id; });
          if (!lines.length) { toAdd.push({ id: id, quantity: 1, properties: { _velora_gift: '1' } }); return; }
          var keep = lines[0];
          if (keep.quantity !== 1 || !keep.properties || keep.properties._velora_gift !== '1') fix.push(keep);
          lines.slice(1).forEach(function (l) { drop[l.key] = 0; dropCount += 1; });
        });
        // gift lines for a variant that is no longer configured
        giftLines.forEach(function (l) {
          if (GIFT_IDS.indexOf(Number(l.variant_id)) < 0) { drop[l.key] = 0; dropCount += 1; }
        });
        if (dropCount) { changed = true; steps = steps.then(function () { return post('cart/update.js', { updates: drop }); }); }
        fix.forEach(function (line) {
          changed = true;
          steps = steps.then(function () {
            return post('cart/change.js', { id: line.key, quantity: 1, properties: { _velora_gift: '1' } });
          });
        });
        if (toAdd.length) {
          changed = true;
          steps = steps.then(function () { return post('cart/add.js', { items: toAdd }); });
        }
      }
      if (!changed) return null;
      return steps.then(readCart);
    });
  }

  function refreshBubble() {
    nativeFetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target || !data['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-icon-bubble'];
        var fresh = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
        if (fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* the counter updates on the next page load */ });
  }

  /* Tell the theme the cart changed so the cart page, the drawer and the Velora UI re-render. */
  function announce(cart) {
    refreshBubble();
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'velora-gifts', cartData: cart });
      }
    } catch (_) { /* fall through to the reload */ }
    var onCartPage = /\/cart\/?$/.test(location.pathname);
    var inChooser = document.documentElement.classList.contains('vd-lock');
    if (onCartPage && !inChooser) {
      // the theme's cartUpdate does not reliably redraw the cart page: re-render its sections in place
      renderCartPage().then(function () {
        // own-source event: every listener (here, in velora.js, cart-cta, delivery) is expected to ignore or only refresh on it, no loop
        try { document.dispatchEvent(new CustomEvent('velora:cart-changed', { detail: { source: 'velora-gifts' } })); } catch (_) {}
      }, reloadOnce);
      return;
    }
    try { document.dispatchEvent(new CustomEvent('velora:cart-changed', { detail: { source: 'velora-gifts' } })); } catch (_) {}
  }

  /* Re-render the cart page sections (cart list + footer) with the Section Rendering API. */
  function renderCartPage() {
    var targets = [];
    var wrappers = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      if (w.querySelector('cart-items, #main-cart-footer')) targets.push(w);
    }
    if (!targets.length) return Promise.reject(new Error('no cart sections'));
    var ids = targets.map(function (w) { return w.id.replace('shopify-section-', ''); });
    return nativeFetch(location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('sections ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var parsed = targets.map(function (w, n) {
          var html = data[ids[n]];
          if (!html) throw new Error('missing section ' + ids[n]);
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#' + w.id) || tmp.firstElementChild;
          if (!fresh) throw new Error('empty section ' + ids[n]);
          return fresh.innerHTML;
        });
        targets.forEach(function (w, n) { w.innerHTML = parsed[n]; });   // only swap when all sections arrived
      });
  }

  function reloadOnce() {
    // last resort: reload at most once per 10 s
    try {
      var last = Number(sessionStorage.getItem('velora:gifts:reload') || 0);
      if (Date.now() - last < 10000) return;
      sessionStorage.setItem('velora:gifts:reload', String(Date.now()));
    } catch (_) { return; }
    location.reload();
  }

  function run(known) {
    var changedAny = false;
    var passes = 0;
    function next() {
      rerun = false;
      passes += 1;
      return pass(passes === 1 ? known : null).then(function (cart) {
        if (cart) { changedAny = true; announce(cart); }
        if (rerun && passes < 3) return next();
        return changedAny;
      });
    }
    return next();
  }

  function sync(known) {
    if (inflight) { rerun = true; return inflight; }
    if (Date.now() - failedAt < 30000) return Promise.resolve(false);   // do not hammer after an error
    inflight = run(known).catch(function (err) {
      failedAt = Date.now();
      warnOnce('Sync failed: ' + (err && err.message ? err.message : err));
      return false;
    }).then(function (changed) {
      inflight = null;
      return changed;
    });
    return inflight;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  window.VeloraGifts = { sync: sync };

  /* ---------- triggers ---------- */
  // 1) the cart page
  if (/\/cart\/?$/.test(location.pathname)) schedule();

  // 2) the theme's own cart events (not ours)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'velora-gifts') return;
        schedule();
      });
    } catch (_) {}
  }
  document.addEventListener('velora:cart-changed', function (event) {
    if (event && event.detail && event.detail.source === 'velora-gifts') return;
    schedule();
  });

  // 2b) coming back from checkout with the browser back button: the page may come from the back/forward cache
  // (or the HTTP cache) and show a stale cart list without the gift lines. Sync, then ALWAYS re-render the cart
  // sections from the server so the visible list matches /cart.js, even when the sync changed nothing.
  function isBackForward() {
    try {
      var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') return true;
      return !!(window.performance && performance.navigation && performance.navigation.type === 2);
    } catch (_) { return false; }
  }
  window.addEventListener('pageshow', function (event) {
    if (!(event && event.persisted) && !isBackForward()) return;
    failedAt = 0;   // a stale failure from before the checkout must not block the sync
    var onCartPage = /\/cart\/?$/.test(location.pathname);
    if (!onCartPage) { schedule(); return; }
    sync().then(function () {
      if (document.documentElement.classList.contains('vd-lock')) return;
      return renderCartPage().then(function () {
        try { document.dispatchEvent(new CustomEvent('velora:cart-changed', { detail: { source: 'velora-gifts' } })); } catch (_) {}
      });
    }).catch(function () { /* the next cart change re-renders */ });
  });

  // 3) any fetch to /cart/add, /cart/change, /cart/update (our own requests use the native fetch and are not seen)
  window.fetch = function (input) {
    var promise = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
        promise.then(function (response) { if (response && response.ok) schedule(); }, function () {});
      }
    } catch (_) {}
    return promise;
  };

  // 4) the cart drawer opening
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var wasOpen = false;
    new MutationObserver(function () {
      var open = drawer.classList.contains('active') || drawer.classList.contains('open') || drawer.hasAttribute('open');
      if (open && !wasOpen) schedule();
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
